"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var util_1 = require("../../utils/util");
var queryable_1 = require("./queryable");
var ContentTypes = (function (_super) {
    __extends(ContentTypes, _super);
    function ContentTypes(baseUrl, path) {
        if (path === void 0) { path = "contenttypes"; }
        _super.call(this, baseUrl, path);
    }
    ContentTypes.prototype.getById = function (id) {
        var ct = new ContentType(this);
        ct.concat("('" + id + "')");
        return ct;
    };
    ContentTypes.prototype.addAvailableContentType = function (contentTypeId) {
        var _this = this;
        var postBody = JSON.stringify({
            "contentTypeId": contentTypeId,
        });
        return new ContentTypes(this, "addAvailableContentType").postAs({ body: postBody }).then(function (data) {
            return {
                contentType: _this.getById(data.id),
                data: data,
            };
        });
    };
    ContentTypes.prototype.add = function (id, name, description, group, additionalSettings) {
        var _this = this;
        if (description === void 0) { description = ""; }
        if (group === void 0) { group = "Custom Content Types"; }
        if (additionalSettings === void 0) { additionalSettings = {}; }
        var postBody = JSON.stringify(util_1.Util.extend({
            "__metadata": { "type": "SP.ContentType" },
            "Id": { "StringValue": id },
            "Name": name,
            "Group": group,
            "Description": description,
        }, additionalSettings));
        return this.post({ body: postBody }).then(function (data) {
            return { contentType: _this.getById(data.id), data: data };
        });
    };
    return ContentTypes;
}(queryable_1.QueryableCollection));
exports.ContentTypes = ContentTypes;
var ContentType = (function (_super) {
    __extends(ContentType, _super);
    function ContentType(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    Object.defineProperty(ContentType.prototype, "fieldLinks", {
        get: function () {
            return new queryable_1.Queryable(this, "fieldLinks");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentType.prototype, "fields", {
        get: function () {
            return new queryable_1.Queryable(this, "fields");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentType.prototype, "parent", {
        get: function () {
            return new ContentType(this, "parent");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentType.prototype, "workflowAssociations", {
        get: function () {
            return new queryable_1.Queryable(this, "workflowAssociations");
        },
        enumerable: true,
        configurable: true
    });
    return ContentType;
}(queryable_1.QueryableInstance));
exports.ContentType = ContentType;
